import type { FileWithPath } from '@mantine/dropzone';
import type {
  PostDocumentExternalFilesUploadRequestType,
  PostDocumentExternalFilesUploadResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const postDocumentExternalFilesUpload = async (
  params: PostDocumentExternalFilesUploadRequestType,
) => {
  const { documentId, ...body } = params;
  const url = `api/v2/documents/${documentId}/external-files`;

  const formData = new FormData();
  body.files.forEach(file => {
    formData.append('files[]', file as FileWithPath);
  });

  const response =
    await apiAuthClient.post<PostDocumentExternalFilesUploadResponseType>(
      url,
      formData,
    );

  return response.data.data;
};
